module.exports = __webpack_public_path__ + "img/guido-filtro.de8484d9.png";